import React from 'react'
import pluralize from 'lib/string/pluralize'

interface Props {
  singular: string;
  count: number;
  component?: any;
  // Values to be passed to the component
  [key: string]: any;
}

function Pluralize(props: Props) {
  const { component: Component, singular, count, ...rest } = props
  const values = pluralize(props)
  const string = `${values.count} ${values.text}`
  return (
    <Component {...rest}>{string}</Component>
  )
}

Pluralize.defaultProps = {
  component: 'span',
}

export default React.memo<Props>(Pluralize)
